<template>
  <div class="header-wrapper" v-if="!xMobile" v-scroll="handleScroll" :class="{ dark_sub: dark_page }">
    <header :class="{ dark: dark_page, 'bg-transparent': hasVideo }" class="header" ref="header">
      <div class="wrapper">
        <div v-if="!xMobile"
             class="header__burger"
             @click.prevent="hideDropDown">
          <div class="header__burger-in">
            <i></i>
            <i></i>
          </div>
          <!-- .header__burger-in -->
        </div>

        <div class="header__logo">
          <a :href="'/' + lang + '/home'">
            <svg class="icon logo-forestal">
              <use xlink:href="#logo-forestal" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
            </svg>
          </a>
        </div>

        <nav class="header__nav" v-if="links.length > 0">
          <ul>
            <li v-for="(link, key) in links" :key="key" :class="link.cssClass || ''">
              <template v-if="link.slug === 'e-cygnus' || link.slug === 'e-siryon'">
                <a href="javascript:void(0)" @click.prevent="openDropDown(link)">{{ link.title }}</a>
              </template>
              <template v-else>
                <a :href="link.url">{{ link.title }}</a>
              </template>
            </li>
          </ul>
        </nav>

        <nav v-if="!xMobile" class="header__controls">
          <ul>
            <li v-if="getShowPages">
              <a :href="'/' + lang + '/bag'">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M7.52747 5.5C7.77623 3.25016 9.6839 1.5 12 1.5C14.3161 1.5 16.2238 3.25016 16.4725 5.5H7.52747ZM6.52243 5.5C6.77507 2.69689 9.13115 0.5 12 0.5C14.8688 0.5 17.2249 2.69689 17.4776 5.5H19.7476C20.6603 5.5 21.4447 6.18036 21.5176 7.09629L21.5176 7.09634L22.4907 19.3101C22.6304 21.049 21.2075 22.5 19.4491 22.5H4.55091C2.79209 22.5 1.3712 21.0487 1.50928 19.3106L1.50929 19.3104L2.48371 7.09634L2.48372 7.09624C2.55665 6.18034 3.34105 5.5 4.25373 5.5H6.52243ZM17 6.5H7H4.25373C3.83236 6.5 3.50972 6.80915 3.48056 7.17566L3.48055 7.17576L2.50614 19.3897L2.50613 19.3899C2.41729 20.5095 3.33804 21.5 4.55091 21.5H19.4491C20.6625 21.5 21.5838 20.5091 21.4939 19.3902L21.4939 19.3899L20.5208 7.17571L20.5208 7.17566C20.4916 6.80915 20.169 6.5 19.7476 6.5H17Z" fill="#000"/>
                </svg>
                <div v-if="count > 0" class="label">{{ count }}</div>
              </a>
            </li>

            <li>
              <a :href="profileLink">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 1.50001L11.8653 1.5C9.1597 1.49989 7.66322 1.49982 6.4445 1.93589C4.34245 2.68801 2.68801 4.34245 1.93589 6.4445C1.49982 7.66322 1.49989 9.1597 1.5 11.8653L1.50001 12L1.5 12.1347C1.49989 14.8403 1.49982 16.3368 1.93589 17.5555C2.28532 18.5321 2.82953 19.4121 3.5229 20.1499C3.54728 20.2277 3.5911 20.3007 3.65418 20.3611C3.7117 20.4162 3.77895 20.4548 3.85013 20.4771C4.5879 21.1705 5.46789 21.7147 6.4445 22.0641C7.66322 22.5002 9.1597 22.5001 11.8653 22.5L12 22.5L12.1347 22.5C14.8403 22.5001 16.3368 22.5002 17.5555 22.0641C18.5987 21.6909 19.5317 21.0953 20.2989 20.3332C20.3157 20.3206 20.332 20.3067 20.3476 20.2917C20.369 20.271 20.3882 20.2488 20.4051 20.2254C21.1329 19.4725 21.7027 18.5657 22.0641 17.5555C22.5002 16.3368 22.5001 14.8403 22.5 12.1347L22.5 12L22.5 11.8653C22.5001 9.1597 22.5002 7.66322 22.0641 6.4445C21.312 4.34245 19.6576 2.68801 17.5555 1.93589C16.3368 1.49982 14.8403 1.49989 12.1347 1.5L12 1.50001ZM19.9809 19.2039C20.4711 18.6222 20.8602 17.9519 21.1226 17.2186C21.4926 16.1844 21.5 14.8765 21.5 12C21.5 9.12354 21.4926 7.81563 21.1226 6.78139C20.4713 4.96125 19.0388 3.52869 17.2186 2.87743C16.1844 2.50738 14.8765 2.50001 12 2.50001C9.12354 2.50001 7.81563 2.50738 6.78139 2.87743C4.96125 3.52869 3.52869 4.96125 2.87743 6.78139C2.50738 7.81563 2.50001 9.12354 2.50001 12C2.50001 14.8765 2.50738 16.1844 2.87743 17.2186C3.14504 17.9666 3.54459 18.649 4.04874 19.2388C6.46696 16.8613 9.16322 15.5 12.0319 15.5C14.8883 15.5 17.5716 16.8476 19.9809 19.2039ZM4.75542 19.9463C5.34648 20.4528 6.031 20.8541 6.78139 21.1226C7.81563 21.4926 9.12354 21.5 12 21.5C14.8765 21.5 16.1844 21.4926 17.2186 21.1226C17.9837 20.8488 18.6804 20.437 19.2793 19.9164C16.9965 17.6843 14.5502 16.5 12.0319 16.5C9.50437 16.5 7.04654 17.6953 4.75542 19.9463ZM12.0128 6.25001C10.3682 6.25001 9.03907 7.57497 9.03907 9.20001C9.03907 10.8261 10.3681 12.15 12.0128 12.15C13.6585 12.15 14.9864 10.8262 14.9864 9.20001C14.9864 7.57486 13.6584 6.25001 12.0128 6.25001ZM8.03907 9.20001C8.03907 7.01625 9.82237 5.25001 12.0128 5.25001C14.2044 5.25001 15.9864 7.01635 15.9864 9.20001C15.9864 11.3849 14.2043 13.15 12.0128 13.15C9.82248 13.15 8.03907 11.385 8.03907 9.20001Z" fill="#000"/>
                </svg>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </header>
    <div class="menu" style="z-index: 999" v-if="links">
      <div class="menu__in">
        <ul>
          <li v-for="(link, key) in links" :key="key">
            <template v-if="link.slug === 'e-cygnus' || link.slug === 'e-siryon'">
              <a
                href="javascript:void(0)"
                @click.prevent="openDropDown(link)"
              >
                {{ link.title }}
              </a>
            </template>
            <template v-else>
              <a :href="link.url">{{ link.title }}</a>
            </template>
          </li>
        </ul>
      </div>
    </div>

    <div class="header-dropdown"
         v-show="isDropdown"
         :class="[{'cygnus-dropdown' : dropDownModelTitle === 'Cygnus'}, {'siryon-dropdown' : dropDownModelTitle === 'Siryon'}]"
    >
      <div class="header-dropdown__back" @click.prevent="hideDropDown">{{ dropDownModelTitle }}</div>
      <ul>
        <li>
          <a :href="dropdownLink('ebike')">
            <img :src="eBikeImage" :alt="selectedModel">
            <span>Pedal assisted</span>
          </a>
        </li>
        <li>
          <a :href="dropdownLink('muscular')">
            <img :src="muscularImage" :alt="selectedModel">
            <span>Non-assisted</span>
          </a>
        </li>
      </ul>
    </div>

    <div class="wrapper">
      <div class="btn-up-wrap" :class="{ hidden: scY < 300 }">
        <button type="button" :class="{ hidden: sc }" class="btn-up" @click="toTop"></button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import ClickOutside from 'vue-click-outside'

gsap.registerPlugin(ScrollTrigger);

export default {
  props: ["lang", "trans"],
  directives: {
    ClickOutside
  },
  data() {
    return {
      token: localStorage.getItem("access_token") || "",
      scrollTop: 0,
      xMobile: false,
      hasVideo: !!document.querySelector(".main__video"),
      sc: false,
      scY: 0,
      scTimer: 0,
      isDropdown: false,
      selectedModel: null
    };
  },
  created() {
    this.loadModels();
    this.AuthUserEmail();
    this.loadCartCount();
  },
  mounted() {
    document.addEventListener('click', e => {
      if (e.target.closest) {
        if (!e.target.closest(".header-dropdown") && !e.target.closest(".header__nav")) {
          this.hideDropDown()
        }
      }
    })

    this.isDropdown = false
    this.selectedModel = null

    this.initTransparentHeader();
    window.addEventListener("scroll", this.upScroll);
    // var headerBlock = document.querySelector('header.header');

    // headerBlock.style.transform = 'translateY(-100%)';
    // headerBlock.style.transition = 'transform 1s';
    // setTimeout(() => {
    //   headerBlock.style.transform = 'translateY(0)';
    // }, 10);

    let metas = document.getElementsByTagName("meta");
    let xMobileMeta;
    for (let meta of metas) {
      if (meta.getAttribute("name") === "x-mobile") {
        xMobileMeta = meta;
        break;
      }
    }
    if (xMobileMeta) {
      this.xMobile = xMobileMeta.getAttribute("content") === "1";
      if (this.xMobile) {
        document.querySelector("body").style.paddingTop = "0px";
      }
    }
    this.scrollTop = window.scrollY;
    if (this.dark_page) {
      document.querySelector("body").style.backgroundColor = "#000";
    }

    if (document.querySelector(".page-header-wrap")) {
      var header = document.querySelector("header.header");

      ScrollTrigger.create({
        trigger: document.querySelector(".page-header-wrap"),
        onToggle: (self) => {
          header.classList.toggle("bg-transparent", self.isActive);
        },
      });
    }
  },
  computed: {
    ...mapGetters({
      allModels: "allModels",
      count: "baskets/count",
      isAuth: "isAuth",
      getShowPages: "getShowPages",
    }),
    eBikeImage() {
      return `${process.env.MIX_AWS_URL}202404/e-${this.selectedModel}/navigation/white.png`
    },
    muscularImage() {
      return `${process.env.MIX_AWS_URL}202404/${this.selectedModel}/navigation/white.png`
    },
    dropDownModelTitle() {
      switch (this.selectedModel) {
        case 'cygnus':
          return "Cygnus"
        case 'siryon':
          return "Siryon"
        default:
          return ""
      }
    },
    profileLink() {
      return !!this.isAuth ? `/${this.lang}/profile` : `/${this.lang}/login`;
    },
    models() {
      return this.allModels.filter((model) => {
        return !!model["show_menu"];
      });
    },
    dark_page() {
      //!NUXT! NOT WORK
      let location = window.location.toString();
      return (
        location.includes("products/hydra") ||
        location.includes("products/aryon-sc")
      );
    },
    links() {
      let links = [];

      [].forEach.call(this.models, (model) => {
        let slug = model.slug
        let title = model.model.replace("e-", "")

        slug = slug.replace("e-", "")

        links.push({
          title: title,
          // url: !model.coming_soon ? `/${this.lang}/products/${model.slug}` : null,
          url: `/${this.lang}/products/${slug}`,
          slug: model.slug
        });
      });

      // links.push({
      //   title: 'All bikes',
      //   url: `/${this.lang}/catalog`,
      //   cssClass: 'last'
      // });

      return links;
    },
  },
  methods: {
    ...mapActions(["getModels", "AuthUserEmail"]),
    hideDropDown() {
      this.$nextTick(() => {
        if (this.isDropdown) {
          this.isDropdown = false
          this.$set(this.$data, 'selectedModel', null)
        }
      })
    },
    dropdownLink(type) {
      let link
      switch (this.selectedModel) {
        case 'cygnus':
        case 'siryon':
          link = `/${this.lang}/products/${this.selectedModel}`
          break;
        default:
          break;
      }

      if (link) {
        if (type === 'muscular') {
          link += "/muscular"
        }
      }

      return link || ""
    },
    setDropDownModel(slug) {
      if (slug === 'e-cygnus' || slug === 'e-siryon') {
        this.$set(this.$data, 'selectedModel', slug.replace("e-", ""))
        this.isDropdown = true
      } else {
        this.$set(this.$data, 'selectedModel', null)
        this.isDropdown = false
      }
    },
    openDropDown(link) {
      setTimeout(() => {
        if (!this.isDropdown) {
          this.setDropDownModel(link.slug)
        } else {
          if (!!link.slug && !!this.selectedModel && link.slug !== this.selectedModel) {
            this.setDropDownModel(link.slug)
          } else {
            this.selectedModel = null
            this.isDropdown = false
          }
        }
      }, 1)
    },
    loadCartCount() {
      this.$store.dispatch("baskets/count", {
        path: this.$path,
      });
    },
    getModelTitle(model) {
      let prefix;
      let language = this.lang;
      prefix = language + "_";
      if (language === "en") {
        prefix = "";
      }
      if (!!model && !!model[`${prefix}model`]) {
        return model[`${prefix}model`];
      }
      return "";
    },
    loadModels() {
      this.getModels({
        path: this.$path,
      });
    },
    submit() {
      this.Logout({
        path: this.$path,
        lang: this.lang,
      });
    },
    handleScroll(event, element) {
      if (window.outerWidth > 767) {
        if (window.scrollY) {
          if (this.isDropdown) {
            this.isDropdown = false
            this.$set(this.$data, 'selectedModel', null)
          }
        }
      }
      if (location.href.indexOf("with-us") !== -1) {
        if (window.outerWidth < 768) {
          let scrollTop = window.scrollY;
          if (scrollTop > this.scrollTop) {
            if (window.scrollY > 58) {
              element.classList.add("hideHeader");
            } else {
              element.classList.remove("hideHeader");
            }
          } else {
            element.classList.remove("hideHeader");
          }
          this.scrollTop = scrollTop;
        }
      }
    },
    initTransparentHeader() {
      if (this.$refs.header && document.querySelector(".main__video")) {
        ScrollTrigger.create({
          trigger: document.querySelector(".main__video"),
          onToggle: (self) => {
            this.$refs.header.classList.toggle("bg-transparent", self.isActive);
            setTimeout(() => {
              this.$refs.header.removeAttribute("style");
            }, 1000);
          },
          onRefreshInit: (self) => {
            this.$refs.header.classList.toggle("bg-transparent", self.isActive);
          },
        });
      }
    },

    upScroll: function () {
      if (this.scTimer) return;
      this.sc = true;
      this.scTimer = setTimeout(() => {
        this.scY = window.scrollY;
        clearTimeout(this.scTimer);
        this.scTimer = 0;
        this.sc = false;
      }, 1500);
    },
    toTop: function () {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.header__nav {
  width: 100%;

  ul {
    li:first-of-type {
      margin-left: auto;
    }

    li:last-of-type {
      margin-right: auto;
    }

    li.last {
      margin-left: auto;
    }
  }
}

.header.dark {
  & ~ .wrapper {
    .btn-up-wrap {
      .btn-up {
        background: rgba(71, 71, 71, 0.5);

        &:before {
          filter: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(0%) hue-rotate(49deg) brightness(103%) contrast(103%);
        }
      }
    }
  }
}

.header-dropdown {
  padding: 80px 20px 80px;
  position: fixed;
  left: 0;
  width: 100%;
  //background: linear-gradient(180deg, #ffffff 10%, rgba(0, 0, 0, 0) 100%);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.95) 0%, rgba(255, 255, 255, 0.56) 44.71%, rgba(255, 255, 255, 0) 100%);
  top: 0;
  z-index: 1999;

  &.cygnus-dropdown {
    ul {
      padding-right: 186px;
      @media (max-width: 992px) {
        padding-right: 122px;
      }
      @media (max-width: 767px) {
        padding-right: 0;
      }
    }
  }

  &.siryon-dropdown {
    ul {
      padding-left: 182px;
      @media (max-width: 992px) {
        padding-left: 167px;
      }
      @media (max-width: 767px) {
        padding-left: 0;
      }
    }
  }

  &:after,
  &:before{
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 320px;
    //background: linear-gradient(180deg, #ffffff 10%, rgba(0, 0, 0, 0) 100%);
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.95) 0%, rgba(255, 255, 255, 0.56) 44.71%, rgba(255, 255, 255, 0) 100%);
    z-index: -1;
  }

  &__back {
    display: none;
    font-size: 18px;
    line-height: 20px;
    font-weight: bold;
    margin: 16px 0 16px 56px;
    align-items: center;

    &:before {
      content: "";
      background-image: url('/images/arr-bottom.svg');
      background-position: center;
      background-repeat: no-repeat;
      background-size: 12px;
      transform: rotate(90deg);
      margin: 2px 16px 0 0;
      width: 18px;
      height: 18px;
      padding: 0;

      body.safari & {
        margin-top: -2px;
      }
    }
  }

  ul {
    display: flex;
    justify-content: center;
    align-items: flex-start;

    li {
      margin: 0 30px;

      a {
        display: flex;
        flex-direction: column;
        font-size: 14px;
        line-height: 16px;
        text-decoration: none;
        color: #474747;

        &:hover {
          color: #858585;
        }

        img {
          width: 135px;
          height: 100px;
          object-fit: contain;
        }

        span {
          //padding-top: 20px;
          margin: 0 auto;
        }
      }
    }
  }


  body:not(.menu--opened) .header.bg-transparent ~ &,
  body:not(.menu--opened) .header[style='background-color: black;'] ~ &,
  body:not(.menu--opened) .header.dark ~ & {
    background: linear-gradient(180deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0) 100%);

    &:after,
    &:before{
      background: linear-gradient(180deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0) 100%);
    }
    &:after{
      top: -24px;
    }
    &:before{
      top: -8px;
    }
    @media (max-width: 767px) {
      background: #fff;
    }

    .header-dropdown__back {
      color: #fff;

      &:before {
        filter: invert(1);
      }
    }

    ul {
      li {
        a {
          color: #fff;

          &:hover {
            color: #C4C4C4;
          }
        }
      }
    }
  }


  @media (max-width: 767px) {
    padding: 56px 20px 60px;
    height: 100%;
    background: #fff;
    overflow: auto;
    .header-dropdown__back {
      display: flex;
    }
    ul {
      padding-top: 60px;

      li {
        a {
          img {
            width: 190px;
            height: 140px;
            max-height: 38vh;
          }
        }
      }
    }
    &:before,
    &:after {
      display: none;
    }
  }
  @media (max-width: 500px) {
    .header-dropdown__back {
      font-size: 14px;
      line-height: 16px;
    }
    ul {
      flex-direction: column;
      align-items: center;
      padding-top: 20px;

      li {
        margin: 0 0 60px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
  @media (max-height: 380px) {
    ul {
      padding-top: 20px;
    }
  }
}

.btn-up-wrap {
  margin-left: auto;
  width: 56px;
  transition: 0.8s;

  opacity: 1;

  &.hidden {
    opacity: 0;
    animation-timing-function: ease-in;
  }

  @media (max-width: 991px) {
    width: 48px;
  }
  @media (max-width: 767px) {
    width: 40px;
  }

  .btn-up {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 56px;
    height: 56px;
    border-radius: 100%;
    background-color: rgba(245, 245, 245, 0.8);
    backdrop-filter: saturate(180%) blur(10px);
    position: fixed;
    bottom: 96px;
    z-index: 990;
    transition: 0.8s;

    opacity: 1;

    &.hidden {
      opacity: 0;
      animation-timing-function: ease-in;
    }

    &[style="background-color: rgb(71, 71, 71);"]:before {
      filter: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(0%) hue-rotate(49deg) brightness(103%) contrast(103%);
    }

    &:before {
      content: "";
      width: 24px;
      height: 24px;
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
      background-image: url("/images/ic-arrow-top-24.svg");
    }

    @media (max-width: 991px) {
      width: 48px;
      height: 48px;
    }
    @media (max-width: 767px) {
      width: 40px;
      height: 40px;
    }
  }
}
</style>
